import { css as u, LitElement as v, nothing as i, html as o } from "lit";
import { property as r, customElement as g } from "lit/decorators.js";
import { b as h, f as m } from "./styles-scZ6dVz-.js";
import "./ark-status-dot-1QrSpBdV.js";
var b = Object.defineProperty, x = Object.getOwnPropertyDescriptor, t = (a, n, p, l) => {
  for (var s = l > 1 ? void 0 : l ? x(n, p) : n, d = a.length - 1, c; d >= 0; d--)
    (c = a[d]) && (s = (l ? c(n, p, s) : c(s)) || s);
  return l && s && b(n, p, s), s;
};
let e = class extends v {
  constructor() {
    super(...arguments), this.title = "", this.status = "idle", this.expandable = !1, this.expanded = !1, this.compact = !1;
  }
  get statusVariant() {
    switch (this.status) {
      case "running":
      case "success":
        return "success";
      case "processing":
        return "info";
      case "warning":
        return "warning";
      case "error":
        return "danger";
      case "idle":
      default:
        return "neutral";
    }
  }
  get statusPulse() {
    return this.status === "processing" || this.status === "running";
  }
  get jobTypeClass() {
    if (!this.jobType) return "";
    const a = this.jobType.toLowerCase();
    return a.includes("immediate") ? "immediate" : a.includes("scheduled") || a.includes("cron") ? "scheduled" : a.includes("manual") ? "manual" : "";
  }
  handleHeaderClick() {
    this.expandable && (this.expanded = !this.expanded, this.dispatchEvent(
      new CustomEvent(this.expanded ? "ark-expand" : "ark-collapse", {
        bubbles: !0,
        composed: !0
      })
    ));
  }
  render() {
    return o`
      <div class="item" part="item">
        <div
          class="header"
          part="header"
          @click=${this.handleHeaderClick}
          role=${this.expandable ? "button" : i}
          aria-expanded=${this.expandable ? this.expanded : i}
        >
          <div class="status" part="status">
            <ark-status-dot
              variant=${this.statusVariant}
              size="md"
              ?pulse=${this.statusPulse}
            ></ark-status-dot>
          </div>

          <div class="content" part="content">
            <div class="title-row">
              <h3 class="title" part="title">${this.title}</h3>
              ${this.jobType ? o`<span class="type-badge ${this.jobTypeClass}">${this.jobType}</span>` : i}
            </div>

            <div class="meta" part="meta">
              ${this.schedule ? o`
                    <span class="meta-item">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <circle cx="12" cy="12" r="10"></circle>
                        <polyline points="12 6 12 12 16 14"></polyline>
                      </svg>
                      ${this.schedule}
                    </span>
                  ` : i}
              ${this.lastRun ? o`
                    <span class="meta-item">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
                        <path d="M3 3v5h5"></path>
                      </svg>
                      ${this.lastRun}
                    </span>
                  ` : i}
              <slot></slot>
            </div>

            <div class="tags">
              <slot name="tags"></slot>
            </div>
          </div>

          <div class="actions" part="actions">
            <slot name="actions"></slot>
            ${this.expandable ? o`
                  <span class="expand-icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                  </span>
                ` : i}
          </div>
        </div>

        ${this.expandable && this.expanded ? o`
              <div class="details" part="details">
                <slot name="details"></slot>
              </div>
            ` : i}
      </div>
    `;
  }
};
e.styles = [
  h,
  m,
  u`
      :host {
        display: block;
      }

      .item {
        background-color: var(--r5-bg-surface);
        border: 1px solid var(--r5-border);
        border-radius: var(--r5-radius-lg);
        transition: all var(--r5-duration-fast);
      }

      .item:hover {
        border-color: var(--r5-border-hover);
      }

      .header {
        display: flex;
        align-items: flex-start;
        gap: var(--r5-space-3);
        padding: var(--r5-space-4);
        cursor: default;
      }

      :host([expandable]) .header {
        cursor: pointer;
      }

      :host([expandable]) .header:hover {
        background-color: var(--r5-bg-hover);
        border-radius: var(--r5-radius-lg);
      }

      .status {
        flex-shrink: 0;
        padding-top: var(--r5-space-1);
      }

      .content {
        flex: 1;
        min-width: 0;
      }

      .title-row {
        display: flex;
        align-items: center;
        gap: var(--r5-space-2);
        flex-wrap: wrap;
      }

      .title {
        font-size: var(--r5-text-sm);
        font-weight: var(--r5-font-semibold);
        color: var(--r5-text);
        margin: 0;
      }

      .type-badge {
        display: inline-flex;
        align-items: center;
        padding: var(--r5-space-0-5) var(--r5-space-2);
        font-size: var(--r5-text-2xs);
        font-weight: var(--r5-font-bold);
        text-transform: uppercase;
        letter-spacing: 0.05em;
        border-radius: var(--r5-radius-sm);
        background-color: var(--r5-bg-muted);
        color: var(--r5-text-muted);
      }

      .type-badge.immediate {
        background-color: rgba(var(--r5-color-success-500-rgb, 34, 197, 94), 0.1);
        color: var(--r5-color-success-700);
      }

      .type-badge.scheduled {
        background-color: rgba(var(--r5-color-info-500-rgb, 59, 130, 246), 0.1);
        color: var(--r5-color-info-700);
      }

      .type-badge.manual {
        background-color: rgba(var(--r5-color-warning-500-rgb, 234, 179, 8), 0.1);
        color: var(--r5-color-warning-700);
      }

      .meta {
        display: flex;
        align-items: center;
        gap: var(--r5-space-4);
        margin-top: var(--r5-space-2);
        font-size: var(--r5-text-xs);
        color: var(--r5-text-muted);
        flex-wrap: wrap;
      }

      .meta-item {
        display: inline-flex;
        align-items: center;
        gap: var(--r5-space-1);
      }

      .meta-item svg {
        width: 14px;
        height: 14px;
        opacity: 0.6;
      }

      .tags {
        display: flex;
        align-items: center;
        gap: var(--r5-space-2);
        margin-top: var(--r5-space-2);
      }

      .actions {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        gap: var(--r5-space-2);
      }

      .expand-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        color: var(--r5-text-muted);
        transition: transform var(--r5-duration-fast);
      }

      :host([expanded]) .expand-icon {
        transform: rotate(180deg);
      }

      .details {
        border-top: 1px solid var(--r5-border);
        padding: var(--r5-space-4);
        background-color: var(--r5-bg-muted);
        border-radius: 0 0 var(--r5-radius-lg) var(--r5-radius-lg);
      }

      /* Compact variant */
      :host([compact]) .header {
        padding: var(--r5-space-3);
      }

      :host([compact]) .title {
        font-size: var(--r5-text-xs);
      }

      :host([compact]) .meta {
        margin-top: var(--r5-space-1);
      }
    `
];
t([
  r({ type: String })
], e.prototype, "title", 2);
t([
  r({ type: String, reflect: !0 })
], e.prototype, "status", 2);
t([
  r({ type: String, attribute: "job-type" })
], e.prototype, "jobType", 2);
t([
  r({ type: String, attribute: "last-run" })
], e.prototype, "lastRun", 2);
t([
  r({ type: String })
], e.prototype, "schedule", 2);
t([
  r({ type: Boolean, reflect: !0 })
], e.prototype, "expandable", 2);
t([
  r({ type: Boolean, reflect: !0 })
], e.prototype, "expanded", 2);
t([
  r({ type: Boolean, reflect: !0 })
], e.prototype, "compact", 2);
e = t([
  g("ark-job-item")
], e);
export {
  e as A
};
//# sourceMappingURL=ark-job-item-bNR6ViBy.js.map
